import { Container, AppBar, Toolbar, Box, Button, Stack } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import PrymeBookingLogo from "../../assets/imgs/logos/PrymeBookingLogo-White.svg"

export default function CustomPageHeader({ logo }) {
  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#fff", color: "#111417" }}
      elevation={1}
    >
      <Container>
        <Toolbar
          disableGutters
          sx={{
            justifyContent: "space-between",
            minHeight: { xs: 56, sm: 64 },
          }}
        >
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              component="img"
              src={logo}
              alt="Store Logo"
              sx={{ height: 40, ml: 1 }}
            />
            <Button
              variant="outlined"
              startIcon={
                <Box
                  component="img"
                  src={PrymeBookingLogo}
                  alt="PrymeBooking Logo"
                  sx={{ height: 20 }}
                />
              }
              component={RouterLink}
              to="/home"
              sx={{
                bgcolor: "#fff",
                color: "#111417",
                borderColor: "#e0e0e0",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 14,
              }}
            >
              Back to TechPryme
            </Button>
          </Stack>
          <Stack direction="row" spacing={2} alignItems="center">
            <Button variant="text" sx={{ color: "#111417", fontWeight: 500 }}>
              Log in
            </Button>
            <Button variant="contained" className="btn-primary">
              Sign in
            </Button>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
